import {z} from "../../../lib";
import {schemaEntityWithId} from "../../../types";
import {SistemaTipo} from "../../../types/enum/enum";

export enum NotificacionVistaFields {
    IdMensaje = 'idMensaje',
    Tipo = 'descTipo',
    Titulo = 'titulo',
    Mensaje = 'mensaje',
    Fecha = 'fecha',
    Prioridad = 'prioridad',
    CodSistema = 'codSistema',
}

export enum NotificacionTipos {
    NUEVO = 'Nuevo Mensaje',
    ATRASADO = 'Mensaje Atrasado'
}

export const schemaNotificacionVista = z
    .object({
        [NotificacionVistaFields.IdMensaje]: z.number(),
        [NotificacionVistaFields.Tipo]: z.nativeEnum(NotificacionTipos),
        [NotificacionVistaFields.Titulo]: z.string(),
        [NotificacionVistaFields.Mensaje]: z.string(),
        [NotificacionVistaFields.Fecha]: z.coerce.date(),
        [NotificacionVistaFields.Prioridad]: z.boolean(),
        [NotificacionVistaFields.CodSistema]: z.nativeEnum(SistemaTipo),
    })
    .merge(schemaEntityWithId)

export type NotificacionVistaDTO = z.infer<typeof schemaNotificacionVista>